export default "__VITE_ASSET__DLVyjmfg__"